import {
  OrderByType,
  useGenericAPI,
  useSingleGenericAPI,
} from "../../../utils/genericAPI/useGenericAPI";
import { Transaction, TransactionPatch } from "../types/transaction.types";
import { useAuth } from "../../auth/hooks";
import { BASE_URL_TRANSACTION, getURLTransaction } from "../services/walletsAPI";
import { useParams } from "react-router-dom";
import useQueryURL from "../../../common/hooks/useQueryURL";

export default function useTransaction(config?: {
  walletId?: string;
  orderBy?: OrderByType<Transaction>;
  pageSize?: number;
}) {
  const { setHeaderAuthToRequest } = useAuth();
  setHeaderAuthToRequest();

  const baseURL = config?.walletId ? getURLTransaction(config?.walletId) : "";

  const { getAllQuery, createNew } = useGenericAPI<
    Transaction,
    Transaction,
    Transaction
  >({
    baseURL,
    APIname: "transactions"+(config?.walletId ? config?.walletId : ""),
    pageSize: config?.pageSize,
    orderBy: config?.orderBy,
  });

  return {
    getAllTransactionQuery: { ...getAllQuery },
    createNewTransactionQuery: {
      ...createNew,
    },
  };
}

export const useSingleTransaction = (id?: string) => {
  const {transactionId} = useParams();
  const query = useQueryURL();
  const idUrl = query.getQueryValue("transactionId");

  const idTransaction =  id || idUrl || transactionId;
  if (!idTransaction) {
    console.error("id is required");
  }
  const { setHeaderAuthToRequest } = useAuth();
  setHeaderAuthToRequest();

  const baseURL = BASE_URL_TRANSACTION
  const { singleQuery  } = useSingleGenericAPI<
    Transaction,
    TransactionPatch
  >({
    baseURL,
    APIname: "transactions-"+(id ? id : ""),
    id: idTransaction,
  });

  return {
    singleTransactionQuery :singleQuery }
}